/**
 * The most vehicles one export may hold — the backend's single catalogue page. Above it the
 * backend refuses with DMS-SU-EX-0001, so the buttons are disabled before the user asks.
 */
export const SOURCING_USER_LIST_EXPORT_LIMIT = 1000;
